import { AxiosResponse } from 'axios'
import { API_HOST } from '../constants'
import { PrevAxios } from '../prev-front-mf-api'
import { handleError } from './utils'
import { PrevAxiosPut } from './types'

export const get = async (path: string, host = API_HOST): Promise<AxiosResponse | undefined> => {
  try {
    const url = `${host}${path}`
    const response = await PrevAxios.get(url)
    return response
  } catch (error) {
    handleError(error)
  }
}

export const post = async (
  path: string,
  data: any,
  headers: any = {},
  host = API_HOST,
): Promise<AxiosResponse | undefined> => {
  try {
    const url = `${host}${path}`
    const response = await PrevAxios.post(url, data, headers)
    return response
  } catch (error) {
    handleError(error)
  }
}

export const put = async (props: PrevAxiosPut): Promise<AxiosResponse | undefined> => {
  try {
    const { path, host, data, headers } = props
    const response = await PrevAxios.put(`${host}${path}`, data, headers)
    return response
  } catch (error) {
    handleError(error)
  }
}
